export default [
    {
        path: '/futures/games',
        component: () => import('@/pages/games'),
    },
    {
        path: '/futures/converts',
        component: () => import('@/pages/v2/onekey'),
    },
  ];
  


// WEBPACK FOOTER //
// ./src/router/v2/games.js